import { HPRole } from '@shared/types';
import {
  IconLMS,
  IconUserSettings,
  IconLauncher,
  IconCommunityHub,
  IconHomeworkStudio,
  IconHomework,
  IconBank,
} from '../icons';

import type { ApplicationType, IApplication } from './types';

export const allApplications: { [key in ApplicationType]: IApplication } = {
  portal: {
    id: 'portal',
    name: 'Home',
    basePath: '/portal',
    enabled: true,
    icon: IconLauncher,
    color: '#3b82f6',
    roles: ['all'],
  },
  classManagements: {
    id: 'classManagements',
    name: 'Class Management',
    basePath: '/lms',
    enabled: true,
    icon: IconBank,
    color: '#075ad7',
    roles: [HPRole.Admin, HPRole.Employee, HPRole.Teacher, HPRole.TA],
  },
  studentStudio: {
    id: 'studentStudio',
    name: 'Student Studio',
    basePath: '/courses',
    enabled: true,
    icon: IconLMS,
    color: '#f59e0b',
    roles: [HPRole.Student],
  },
  homeworkCenters: {
    id: 'homeworkCenters',
    name: 'Homework Centers',
    basePath: '/homework-center',
    enabled: true,
    icon: IconHomework,
    color: '#ef4444',
    roles: [HPRole.Admin, HPRole.Employee, HPRole.Teacher, HPRole.TA],
  },
  homeworkStudio: {
    id: 'homeworkStudio',
    name: 'Homework Studio',
    basePath: '/homework',
    enabled: false,
    icon: IconHomeworkStudio,
    color: '#10b981',
    roles: [HPRole.Admin, HPRole.Employee, HPRole.Teacher, HPRole.TA],
  },
  communicationHub: {
    id: 'communicationHub',
    name: 'Communication Hub',
    basePath: '/hub',
    enabled: false,
    icon: IconCommunityHub,
    color: '#8b5cf6',
    roles: ['all'],
  },
  userSettings: {
    id: 'userSettings',
    name: 'User Settings',
    basePath: '/settings',
    enabled: true,
    icon: IconUserSettings,
    color: '#ef4444',
    roles: ['all'],
  },
};

export const listGeneralApplications = (userRole: string): IApplication[] => {
  return Object.values(allApplications).filter(app => {
    const isEnabled = app.enabled;
    const hasRoleAccess = app.roles.includes('all') || app.roles.includes(userRole);

    return isEnabled && hasRoleAccess;
  });
};
